import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { config } from 'config';

const SITE_KEY = config.turnstile.siteKey;

export default function TurnstileWidget({ onToken }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!SITE_KEY || !containerRef.current) {
      return undefined;
    }

    const renderWidget = () => {
      if (!window.turnstile || !containerRef.current) {
        return;
      }
      if (widgetIdRef.current) {
        window.turnstile.remove(widgetIdRef.current);
      }
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(''),
        'error-callback': () => onToken(''),
      });
    };

    if (window.turnstile) {
      renderWidget();
      return () => {
        if (widgetIdRef.current && window.turnstile) {
          window.turnstile.remove(widgetIdRef.current);
        }
      };
    }

    let script = document.querySelector('script[data-ebi-turnstile]');
    const onLoad = () => renderWidget();

    if (!script) {
      script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.setAttribute('data-ebi-turnstile', 'true');
      document.body.appendChild(script);
    }

    script.addEventListener('load', onLoad);
    return () => {
      script.removeEventListener('load', onLoad);
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
  }, [onToken]);

  if (!SITE_KEY) {
    return null;
  }

  return <div ref={containerRef} className="signup-turnstile" />;
}

TurnstileWidget.propTypes = {
  onToken: PropTypes.func.isRequired,
};
